import { AppStrings } from "../../../utils/constants/AppStrings";
import type { WizardTriggerMode } from "./Campaigns/CreateCampaignWizard/wizardTypes";

/**
 * Built per call so TCM strings that arrive after boot (and language switches)
 * are picked up. Module-scope `AppStrings.X` snapshots freeze English defaults
 * before `loadAppStringsForLanguage` / `setAppString` rebind AppStrings.
 */
export const triggerModeDisplayLabel = (mode: WizardTriggerMode): string => {
  switch (mode) {
    case "event":
      return AppStrings.PAM_DYNAMIC_BONUS_TRIGGER_EVENT;
    case "referral":
      return AppStrings.PAM_DYNAMIC_BONUS_TRIGGER_FRIEND_REFERRAL;
    case "affiliate_referral":
      return AppStrings.PAM_DYNAMIC_BONUS_TRIGGER_AFFILIATE_REFERRAL;
    case "campaign_start":
      return AppStrings.PAM_DYNAMIC_BONUS_TRIGGER_BASIC;
    case "none":
      return AppStrings.PAM_DYNAMIC_BONUS_TRIGGER_SUMMARY_NONE;
    /* istanbul ignore next -- exhaustive never; unreachable at runtime */
    default: {
      const _exhaustive: never = mode;
      return _exhaustive;
    }
  }
};
